<template>
  <div>
    <v-tooltip
      v-if="tooltip != ''"
      top
    >
      <template v-slot:activator="{ on }">
        <div v-on="on">
          <v-switch
            v-model="selected"
            class="isg-custom-switch mt-0"
            :label="`${label}: ${selected?'Да':'Нет'}`"
            :disabled="disabled"
            hide-details
            @change="changeReference"
          />
        </div>
      </template>
      <span>{{ tooltip }}</span>
    </v-tooltip>

    <v-switch
      v-else
      v-model="selected"
      class="isg-custom-switch mt-0"
      :label="`${label}: ${selected?'Да':'Нет'}`"
      :disabled="disabled"
      hide-details
      @change="changeReference"
    />
  </div>
</template>

<script>
export default {
  props: ["value", "label", "tooltip", "disabled"],
  data() {
    return {
      selected: this.value,
    };
  },
  watch: {
    value(newValue) {
      this.selected = newValue;
    },
  },
  methods: {
    changeReference() {
      this.$emit("input", this.selected);
    },
  },
};
</script>
<style>
.isg-custom-switch.v-input--selection-controls .v-input__control {
  margin: 0 auto;
}
.v-input--selection-controls__input {
  align-self: flex-start;
}
</style>
